import { RoomFormDataState, RoomFormDataActionTypes, ROOM_FORM_DATA_REQUEST, ROOM_FORM_DATA_SUCCESS, ROOM_FORM_DATA_FAILURE, ROOM_FORM_DATA_CLEAR } from "store/reducers/room/formData/types";

const defaultState: RoomFormDataState = {
  isLoading: false,
  errorMessage: ""
};

export default function getRoomFormData(state = defaultState, action: RoomFormDataActionTypes): RoomFormDataState {
  switch (action.type) {
    case ROOM_FORM_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case ROOM_FORM_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_FORM_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    case ROOM_FORM_DATA_CLEAR:
      return {
        ...state,
        contents: undefined,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};